/**
 * Calculates the total fat content based on provided ingredients.
 */
export function calculateTotalFat(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalFat = [...ingredients].reduce(addFat, 0);

  return Math.round(totalFat);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.totalFatG !== 'number';
}

function addFat(total: number, ingredient: Ingredient) {
  const fat = typeof ingredient.totalFatG === 'number' ? ingredient.totalFatG : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + fat * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { totalFatG: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
